import SkillsChart from './skillsChart';
import NotableSkill from './notableSkill';
import { Fade } from 'react-awesome-reveal';

const otherSkills: { name: string; mark: number }[] = [
    { name: 'AWS', mark: 4 },
    { name: 'Zustand', mark: 5 },
    { name: 'GraphQL', mark: 5 },
    { name: 'Jest', mark: 5 },
    { name: 'Three.js', mark: 2 },
    { name: 'Docker', mark: 3 },
    { name: 'Git', mark: 4 },
    { name: 'Webpack/parcel', mark: 4 },
    { name: 'HTML5/CSS', mark: 5 },
    { name: 'SCSS', mark: 5 },
    { name: 'MongoDB', mark: 3 },
    { name: 'DynamoDB', mark: 4 },
    { name: 'Github Actions', mark: 4 },
    { name: 'Claude Code/Codex', mark: 3 },
    { name: 'Serverless', mark: 3 },
    { name: 'Illustrator', mark: 3 },
    { name: 'Photoshop', mark: 2 },
];

const AboutMe = () => (
    <div className='aboutMe'>
        <div className='container'>
            <div className='row'>
                <div className='col-md-12'>
                    <Fade>
                        <h2> Welcome to the portfolio of Andrew Dear </h2>
                    </Fade>
                </div>
                <div className='col-md-6'>
                    <Fade> 
                        <h3> Hi, i&#39;m Andy. I am a full stack javascript developer living in Southampton, UK. </h3>
                    </Fade>
                    <Fade>
                        <p className='aboutMeText'>
                            I am highly conscientious and passionate about all aspects of computer science. I Have
                            over {new Date().getFullYear() - 2015} years experience working in the industry and love
                            the fast paced ever evolving nature of it.
                        </p>
                        <p className='whiteText'>
                            I have strong experience working in both heavily weighted front end and back end teams.
                            I feel very confident and enjoy working in both worlds. I also have a strong foundation
                            in devops development. I currently work as a Senior Full Stack Engineer at Jagex.
                            My role has mostly been delivering core P0 business requirements. I have worked across the Core Tech Accounts & Billing teams as well as the Data Engineering team. I've architected and built the martech pipelines that power data flow into our marketing technology systems, engineered integrations for marketing attribution, and ensured our platforms stay compliant with GDPR regulations keeping player data safe while helping the business make smarter, data-driven decisions.
                        </p>
                    </Fade>
                </div>
                <div className='col-md-6'>
                    <Fade>
                        <SkillsChart />
                    </Fade>
                </div>
                <div className='col-md-12'>
                    <Fade>
                        <h4> Other notable skills / experience </h4>
                    </Fade>
                    <div className='row'>
                        {otherSkills.map(({ name, mark }) => (
                            <NotableSkill name={name} mark={mark} key={name} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default AboutMe;
